(function () {
  const GRID_ID = 'facets-results';
  const TRIGGER_ID = 'infinite-scroll-trigger';

  let observer = null;

  function init() {
    const pagination = document.querySelector('.infinite-scroll-pagination');
    if (pagination) pagination.style.display = 'none';

    const trigger = document.getElementById(TRIGGER_ID);
    if (!trigger) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(onIntersect, { rootMargin: '400px' });
    observer.observe(trigger);
  }

  function onIntersect(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const trigger = entry.target;
      const nextUrl = trigger.dataset.nextUrl;
      if (!nextUrl) continue;
      observer.unobserve(trigger);
      loadMore(trigger, nextUrl);
    }
  }

  async function loadMore(trigger, nextUrl) {
    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const grid = document.getElementById(GRID_ID);
      if (grid) {
        parsed.querySelectorAll(`#${GRID_ID} > li`).forEach((item) => {
          grid.appendChild(item);
        });
      }

      const newTrigger = parsed.getElementById(TRIGGER_ID);
      if (newTrigger?.dataset.nextUrl) {
        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
        observer.observe(trigger);
      } else {
        trigger.remove();
        if (grid) {
          const section = grid.closest('section[data-end-message]');
          const endMsg = section?.dataset.endMessage || '';
          const div = document.createElement('div');
          div.className = 'end-of-list-message text-center mt-4';
          div.innerHTML = `<p class="text-sm text-scheme-accent-contrast opacity-70">${endMsg}</p>`;
          grid.insertAdjacentElement('afterend', div);
        }
      }
    } catch (err) {
      console.error('[infinite-scroll]', err);
      const pagination = document.querySelector('.infinite-scroll-pagination');
      if (pagination) pagination.style.display = '';
    }
  }

  init();

  // Re-initialize after filter/sort updates (fired by filterable.js via MutationObserver)
  document.addEventListener('cascade:section:hasmutated', () => {
    setTimeout(init, 50);
  });
})();
